<template>
    <div class="form-group">
        <label>Bonus per livello <b>(1 è l'upliner diretto)</b> <button type="button" class="btn btn-success btn-sm" @click="addRow">+</button></label>
        <div class="d-flex mt-2" v-for="(item, i) in localValue" :key="i">
            <button type="button" class="btn btn-danger btn-sm me-2" @click="removeRow(i)">-</button>
            <div class="me-2">
                <input type="text" :readonly="true" class="form-control" v-model="item.level" />
            </div>
            <div class="me-2 d-flex align-items-center">
                <input type="number" class="form-control" v-model="item.paymentAmount" placeholder="€ pagati" /> <span class="fs-22 ms-2">€</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import * as OM from '@/model';
import { Options, Vue, mixins } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Options({})
export default class bonusPayments extends mixins(WithModel) {

    declare localValue: OM.BonusPaymentLevel[];

    created(){
        if(!this.modelValue){
            this.localValue = [];
            this.emitModel(this.localValue);
        }
    }

    addRow(){
        let toAdd = new OM.BonusPaymentLevel();
        this.localValue.push(toAdd);
    }

    removeRow(index){
        this.localValue.splice(index, 1);
    }

    @Watch('localValue.length')
    onBonusPayments(next, prev){
        this.localValue.forEach((x, i) => {
            x.level = i + 1;
        })
    }

}

</script>
